import React from "react";
import { Line } from "react-chartjs-2";

const RequirementChangeRate = () => {

  const data = {
    labels:["Sprint1","Sprint2","Sprint3","Sprint4"],
    datasets:[
      {
        label:"Requirement Changes",
        data:[2,6,4,3],
        borderColor:"#f97316"
      }
    ]
  };

  return (
    <div className="bg-gray-800 p-5 rounded-xl">
      <h3 className="text-white mb-4">📝 Requirement Change Rate</h3>
      <Line data={data}/>
    </div>
  );
};

export default RequirementChangeRate;